import React from 'react';

import RichText from '@elements/RichText';
import SubModuleSelector from '@submodules/SubModuleSelector';
import { getReputationScoreLabel } from '@utils';
import { getClasses } from '@utils';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import './style.css';

const ScoreOverview = ({
  item,
}): JSX.Element => {
  const image = getImage(item.imageRight?.gatsbyImageData);
  const scoreLabel = getReputationScoreLabel(item.score);
  const scoreClasses = `score-overview__left-side--${scoreLabel.toLowerCase()}`;
  const modulesClasses = getClasses(
    `score-overview__modules-section`,
    item?.modulesWidth && `score-overview__modules-section--${item?.modulesWidth}`,
  );

  const rangeList = [
    'Poor_0-29',
    'Poor_30-39',
    'Weak_40-59',
    'Average_60-69',
    'Strong_70-79',
    'Excellent_80+',
  ];

  return (
    <div className="score-overview--main">
      <section className="score-overview__inner">
        {
          item?.intro && (
            <div className="score-overview__intro-section">
              <RichText bodyRichText={item.intro} />
            </div>
          )
        }
        <div className="score-overview__header-section">
          <h2>{item.title}</h2>
          <strong>{item.date}</strong>
          <p>{item.subtitle}</p>
        </div>
        <div className="score-overview__middle-section">
          <section className="score-overview__middle-section__left-side">
            <blockquote className={scoreClasses}>
              <h1>{item.score}</h1>
              <strong>{scoreLabel}</strong>
            </blockquote>
            <ul>
              {
                rangeList.map(range => (
                  <li key={`${item.id}-rangelist-${range}`} />
                ))
              }
            </ul>
            <p>{item.shortDescription}</p>
          </section>
          <figure className="score-overview__middle-section__right-side">
            {
              image && (
                <GatsbyImage alt={item.imageRight.title} image={image}/>
              )
            }
          </figure>
        </div>
        <div className={modulesClasses}>
          <SubModuleSelector submodules={item.modules} />
        </div>
        {
          item?.footer && (
            <div className="score-overview__footer-section">
              <RichText bodyRichText={item.footer} />
            </div>
          )
        }
      </section>
    </div>
  );
};

export default ScoreOverview;
